import React                                       from 'react';
import MaterialType                                from 'pu-react/components/MaterialType';
import { materialTypeFlex, materialTypeRigidFlex } from '../../data/SelectOptions';

export default (props) => {
  const options = props.parameters.rigid_flex_selector === 'Flex'
    ? materialTypeFlex
    : materialTypeRigidFlex;
  return (
    <MaterialType {...props} options={options} />
  );
};
